import { forwardRef, type Ref, type SVGProps } from 'react';
import { SvgIcon } from '../../components/icon/icon';

interface SVGRProps {
  title?: string;
  titleId?: string;
}
const Yoga = (
  { title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    ref={ref}
    aria-labelledby={titleId}
    {...props}>
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="m14.571 15.504.858 1.845s3.857.819 3.857 2.767c0 1.384-1.716 1.384-1.716 1.384H13l-2.25-1.25m0 0L8.5 21.5H6.43s-1.716 0-1.716-1.384c0-1.948 3.858-2.767 3.858-2.767l.857-1.845m1.321 4.746 2.75-1.75M3 16.426s2.143-.461 3.429-.922C7.714 9.046 11.57 9.507 12 9.507s4.286-.461 5.571 5.997c1.286.46 3.429.922 3.429.922M12 7.5a2 2 0 1 0 0-4 2 2 0 0 0 0 4"
      vectorEffect="non-scaling-stroke"
    />
  </svg>
);
const ForwardRef = forwardRef(Yoga) as SvgIcon;
export { ForwardRef as ReactComponent };
